import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import Vuelidate from 'vuelidate'


Vue.use(Vuex)
Vue.use(Vuelidate)

// const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({

  // strict: debug,

  modules: {
    app: app,
  }

})
